module.exports = __webpack_public_path__ + "img/tab02.ffb76495.jpg";